'use strict'

const React = require('react')
const createReactClass = require('create-react-class')
const PropTypes = require('prop-types')
const SmartyContent = require('../../shared/_layouts/_templates/_includes/smartyContent.jsx')
const Nav = require('../../shared/_layouts/_templates/_includes/nav.jsx')
const Breadcrumb = require('../../shared/_layouts/_templates/_includes/breadcrumb.jsx')
const { smartyIncludes, smartyVariables } = require('../../shared/_layouts/_templates/_includes/smartyIncludes.jsx')
const getAirportInfo = require('../../shared/_layouts/_templates/_includes/getAirportInfo')
const Engine = require('../../shared/_layouts/_templates/_includes/engines/engine-controller.jsx')
const Menu = require('../../shared/_layouts/_templates/_includes/menu.jsx')
// const ExitDiscountModal = require('../../shared/_layouts/_templates/_includes/modals/ExitDiscountModal.jsx')
const CachedPrice = require('../../shared/_layouts/_templates/_includes/pricing/getCachedPrice.jsx')
const PricesExplainedModal = require('../../shared/_layouts/_templates/_includes/modals/PricesExplainedModal.jsx')
const TrackerFix = require('../../shared/_layouts/_templates/_includes/trackerFix')
const Agents = require('../../_plugins/lib/agents')
const Helpers = require('../../_plugins/lib/helpers')
const getPhoneNumbers = require('../../_plugins/lib/phoneNumber')
const DiscountAlert = require('../../shared/_layouts/_templates/_includes/discount-alert.jsx')
const HarpAlert = require('../../shared/_layouts/_templates/_includes/harp-alert.jsx')
const SplitTestStore = require('../../shared/states/splitTestData.jsx')
const { object } = PropTypes

const LandingPages = createReactClass({
  mixins: [Agents, SplitTestStore],

  propTypes: {
    domainSettings: object,
    formSettings: object,
    locations: object,
    RoomTypes: object,
    settings: object,
    pageData: object.isRequired,
    agents: object,
    lastUpdated: object
  },

  getInitialState () {
    return {
      promotionCode: null
    }
  },

  setPromotionCode (code) {
    if (code === this.state.promotionCode) return
    this.setState({ promotionCode: code })
  },

  componentDidMount () {
    const { pageData: { html } } = this.props
    let { agentData: { agent } } = this.state
    const { setVar } = smartyVariables(html)
    if (setVar.agent) {
      agent = setVar.agent
      this.checkAgent(agent, this.updateAgentData)
    }
    let environment = 'production'
    if (Helpers.getParameterByName('data-pipeline-staging')) environment = 'staging'
    if (Helpers.getParameterByName('data-pipeline-production')) environment = 'production'
    TrackerFix({
      agent,
      environment,
      templateGroup: 'core',
      schemaVersions: {
        cache_primer: 'v1.0.0',
        initialise: 'v1.1.0',
        auto_capture: 'v1.1.0',
        capture: 'v1.0.0',
        click: 'v1.0.0',
        focus: 'v1.0.0',
        ipseity: 'v1.0.0',
        load: 'v1.1.0',
        test: 'v1.0.0',
        view: 'v1.0.0'
      }
    })
    window.universalJavascriptLoaded = true
  },

  getEngineProducts (setVar = { }) {
    if (setVar.engineProducts) return setVar.engineProducts.split(',')
    const { pageData: { pageName } } = this.props
    if (pageName.match('parking')) return [ 'cp' ]
    if (pageName.match('hotels')) return [ 'ho', 'hcp' ]
    if (pageName.match('lounges')) return [ 'lo' ]
    return [ ]
  },

  render () {
    const { agentData, phoneNumbers, promotionCode } = this.state
    const { settings, pageData, agents: agentSettings, domainSettings, formSettings, locations, RoomTypes, lastUpdated: { updateddate } } = this.props
    const airport = getAirportInfo(pageData.pageName)
    let hiddenLocation = ''
    if (airport && airport.code) hiddenLocation = airport.code
    const { html } = pageData
    let { setVar, content } = smartyVariables(html)
    content = smartyIncludes(content)
    const productList = this.getEngineProducts(setVar)

    return (
      <div>
        <Nav promotionCodeCallback={this.setPromotionCode} agents={agentSettings} pageData={pageData} settings={settings} />
        <div id='booking-engine' className='row bg-default horizontal-container'>
          <DiscountAlert settings={settings} agentData={agentData} />
          <HarpAlert domainSettings={domainSettings} settings={settings} />
          <h3 className='text-center'>Compare { airport && airport.name + ' ' }Airport Parking</h3>
          <span className='lead text-center block'>Book now from only <span className='priceSmall'><CachedPrice type='perweek' priceFormat={settings.priceFormat} pageData={pageData} id='enginePricing' /></span> for 8 days</span>
          { pageData.pageName === 'stansted-parking' && (
            <PricesExplainedModal id='CPPricesExplainedModal' pageData={pageData} />
          ) }<hr />
          <Engine
            horizontal
            terminalLink
            showFlight
            showFlightDropdown
            productList={productList}
            setVar={setVar}
            domainSettings={domainSettings}
            formSettings={formSettings}
            locations={locations}
            RoomTypes={RoomTypes}
            hiddenLocation={hiddenLocation}
            pageData={pageData}
            agentSettings={agentSettings}
            agentData={agentData}
            promotionCode={promotionCode}
          />
        </div>
        <div className='horizontal-container'>
          <div className='clearfix row'>
            <Breadcrumb pageName={pageData.pageName} />
            <div className='col-md-8'>
              <SmartyContent domainSettings={domainSettings} settings={settings} agentData={agentData} pageData={pageData} theContent={content} phoneNumber={phoneNumbers.number} noSchemaMarkup lastUpdated={updateddate} />
            </div>
            <Menu pageData={pageData} settings={settings} domainSettings={domainSettings} phoneNumber={phoneNumbers.number} agentCode={agentData.agent} />
          </div>
        </div>
        {/* <ExitDiscountModal imageCloudSettings={imageCloudSettings} agentData={agentData} /> */}
      </div>
    )
  }
})

module.exports = getPhoneNumbers(LandingPages)



// WEBPACK FOOTER //
// ./_layouts/_templates/parkingLandingPages.jsx